export default{
    USERINFO( state , data ){
        state.userInfo = data
    },
    ISLOGIN( state , data ){
      state.isLogin = data
    },
    INDEXSEARCHINFO( state , data ){
        state.indexSearchInfo = data
    },
    PROPAGESEARCHPARAMS( state , data ){
        state.proPageSearchParams = data
    },
    AUTHORIZATION( state , data ){
        state.Authorization = data
    },
    PRODUCTSHOWINFO( state , data ){
        state.productShowInfo = data
    },
    PRODUCTROUTERINFO( state , data ){
        state.productRouterInfo = data
    },
    CONCEPTLIST( state , data ){
        state.conceptList = data
    },
    CORENAME( state , data ){
        state.coreName = data
    },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js